<template>
	<div class="skill-item tw-p-4 custom-fade-in">
		<div class="tw-flex tw-justify-between tw-items-center tw-gap-4">
			<span class="text-lg"
				><b>{{ skill.name }}</b> ({{ skill.parent.name }})</span
			>
			<div class="tw-flex tw-gap-4 tw-items-center">
				<close-icon class="cursor-pointer" @click="$emit('closeClicked')"></close-icon>
			</div>
		</div>
		<p-horizontal-divider mx="-1rem" my="1rem" />
		<section class="tw-flex tw-gap-6">
			<div class="tw-w-2/3">
				<p class="tw-text-app-color-primary tw-mb-1">Descripción</p>
				<p class="tw-m-0">
					{{ propOr('-', 'description', skill) }}
				</p>
			</div>
			<div class="tw-flex tw-items-center tw-w-1/3" :class="[has('selectedLevel', skill) ? '' : 'tw-justify-end']">
				<div v-if="has('selectedLevel', skill)">
					<div class="tw-mb-2">
						<b :style="{ color: textToColor(path(['selectedLevel', 'name'], skill)) }">
							{{ path(['selectedLevel', 'name'], skill) }}
						</b>
						<p class="tw-text-app-color-font tw-m-0">
							{{ path(['selectedLevel', 'description'], skill) }}
						</p>
					</div>
					<p-button
						rounded-level="rounded"
						size="small"
						:outlined="true"
						@click="$emit('chooseLevelClicked')"
					>
						Cambiar
					</p-button>
				</div>
				<p-button
					v-if="!has('selectedLevel', skill)"
					@click="$emit('chooseLevelClicked')"
					type="secondary"
					rounded-level="rounded"
				>
					Escoger Nivel
				</p-button>
			</div>
		</section>
	</div>
</template>

<script>
import { has, path, propOr } from 'ramda';
import PHorizontalDivider from '../../../../shared/components/ui/p-horizontal-divider';
import PButton from '../../../../shared/components/ui/p-button';
import CloseIcon from '../../../../shared/components/icons/close-icon';
import textToColor from '../../../../shared/utils/textToColor';

export default {
	name: 'SkillItem',
	props: ['skill'],
	components: { CloseIcon, PButton, PHorizontalDivider },
	methods: {
		propOr,
		path,
		has,
		textToColor,
	},
};
</script>

<style lang="scss">
.skill-item {
	border: 1px solid var(--app-color-gray);
	border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/components/second-step/components/skill-item.vue